module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-relay/~/babel-runtime/core-js/object/assign.js
 ** module id = 159
 ** module chunks = 0
 **/